import posthog from 'posthog-js';
import constVars from '~/constants/constVars';
import { EAnalyticsEvent, ProductType, StepStatus } from '~/enums';
import { IAnalyticEventParams } from '~/Interfaces';
import { AppDispatch, GetStateFunc } from '..';
import { selectStepConfig as selectLoanOfferStepConfig } from '../selectors/loanOffer.selector';
import { pushToGtmHelper } from './analyticsActions.utils';

interface GtmPropsBase {
  stepStatus?: StepStatus;
  actionName?: string;
  errorMessage?: string;
  stepActionNumber?: number;
}

export const pushToGtmLoanAction = ({
  stepStatus,
  actionName,
  stepActionNumber,
  errorMessage,
}: GtmPropsBase) => (_dispatch: AppDispatch, getState: GetStateFunc) => {
  const state = getState();
  const { loanApplication, loanOffer, intl } = state;
  const loanOfferStepConfig = selectLoanOfferStepConfig(state);
  const { market, language } = intl;
  const { pathname } = window.location;

  const isLoanOffer = pathname.includes(`/${constVars.ROUTE_LOAN_OFFER}`);

  const clientType = isLoanOffer
    ? loanOffer.clientType
    : loanApplication.form.clientType;

  const userId = isLoanOffer
    ? loanOffer.overview.clientId
    : loanApplication.userId;

  const userEmail = isLoanOffer
    ? loanOffer.overview.email
    : loanApplication.form.applicant.email;

  const userPhoneNumber = isLoanOffer
    ? loanOffer.overview.phone
    : loanApplication.form.applicant.phone;

  const { clientId, flowType: onboardingApplicationFlowType } = loanApplication;

  const stepNumber = isLoanOffer
    ? loanOffer.currentStep
    : loanApplication.currentStepNumber;

  const stepName = isLoanOffer
    ? loanOfferStepConfig[stepNumber - 1]?.name
    : loanApplication.currentStepName;

  const eventName = isLoanOffer
    ? EAnalyticsEvent.OnboardingOfferFlow
    : EAnalyticsEvent.OnboardingApplicationFlow;

  const { applicationId } = loanApplication.form;

  let timeSpentOnStep;

  if (
    actionName &&
    [
      'next_button_pressed',
      'submit_button_pressed',
      'back_button_pressed',
      'skip_button_pressed',
      'auth_button_pressed',
      'start_manual_flow_pressed',
      'checkpoint_boost_application_click',
      'checkpoint_complete_later_click',
    ].includes(actionName)
  ) {
    const stepStartTimestamp = isLoanOffer
      ? loanOffer.stepStartTimestamp
      : loanApplication.stepStartTimestamp;
    timeSpentOnStep = Math.ceil(
      (new Date().getTime() - new Date(stepStartTimestamp).getTime()) / 1000
    );
  }

  const baseEventProperties: IAnalyticEventParams = {
    eventName,
    product: ProductType.LOAN,
    stepNumber,
    stepName: stepName ?? 'landing_page',
    clientType,
    ...((userId || clientId) && { userId: userId || clientId }),
    market,
    language,
    stepActionNumber: stepActionNumber
      ? stepNumber + stepActionNumber
      : undefined,
    errorMessage,
    actionName,
    stepStatus,
    flowType: !isLoanOffer ? onboardingApplicationFlowType : undefined,
    orderId: !isLoanOffer && !!applicationId ? applicationId : undefined,
    timeSpentOnStep,
    timestamp: new Date().toISOString(),
  };

  const gtmEventProperties = {
    ...baseEventProperties,
    phoneNumber: userPhoneNumber,
    email: userEmail,
  };

  if (window.Cypress) {
    window.posthogCapture(eventName, baseEventProperties);
  }

  posthog.capture(eventName, baseEventProperties);
  pushToGtmHelper(eventName, gtmEventProperties);
};
